namespace Matrix.Visualizer {
    export enum ParentsFilter {
        NoParents = 0,
        ImmediateParents = 1,
        AllAncestors = 2
    }
    Serenity.Decorators.registerEnumType(ParentsFilter, 'Matrix.Visualizer.ParentsFilter');
}
